import { api, signOut } from "../api";
import { h } from "../ui/dom";

export async function accountView(root: HTMLElement) {
  const status = h("p", {role:"status"}, "Loading account…");
  root.replaceChildren(h("h1",null,"Your account"),status);
  try {
    const account = await api<{username:string}>("/auth/session");
    status.textContent = `Signed in as ${account.username}. This is the workspace owner account.`;
    const current = h("input",{type:"password",id:"current-password",autocomplete:"current-password",required:true,maxlength:128}) as HTMLInputElement;
    const password = h("input",{type:"password",id:"new-password",autocomplete:"new-password",required:true,minlength:15,maxlength:128}) as HTMLInputElement;
    const confirm = h("input",{type:"password",id:"confirm-password",autocomplete:"new-password",required:true,minlength:15,maxlength:128}) as HTMLInputElement;
    const message = h("p",{role:"status"});
    const submit = h("button",{type:"submit"},"Change password") as HTMLButtonElement;
    const form = h("form",{class:"card account-password"},h("h2",null,"Change password"),
      h("label",{for:"current-password"},"Current password"),current,
      h("label",{for:"new-password"},"New password"),password,
      h("p",{class:"muted"},"Use 15–128 characters. Changing your password signs out all devices."),
      h("label",{for:"confirm-password"},"Confirm new password"),confirm,message,submit);
    form.addEventListener("submit",async event=>{
      event.preventDefault(); if(submit.disabled)return;
      if(password.value!==confirm.value){message.textContent="The passwords do not match.";return;}
      submit.disabled=true;
      try {
        await api("/auth/password",{method:"POST",body:JSON.stringify({currentPassword:current.value,password:password.value})});
        current.value=password.value=confirm.value="";
        window.location.hash="/"; window.location.reload();
      } catch(e){message.textContent=e instanceof Error?e.message:"Could not change password.";}
      finally {submit.disabled=false;}
    });
    const revoke = h("button",{type:"button",class:"secondary"},"Sign out all devices") as HTMLButtonElement;
    revoke.onclick=async()=>{
      revoke.disabled=true;
      try {await signOut(true);window.location.hash="/";window.location.reload();}
      catch(e){message.textContent=e instanceof Error?e.message:"Could not sign out devices.";revoke.disabled=false;}
    };
    root.append(form,h("section",{class:"card account-password"},h("h2",null,"Signed-in devices"),
      h("p",null,"Sign out every browser, including this one. This leaves your clients, websites and platform connections in place."),revoke));
  } catch(e){status.textContent=e instanceof Error?e.message:"Could not load account.";}
}
